import { DisplayListComponent } from "Components/Shared";
import { BATCH } from "App/constants";

const Batches = () => {
  return <DisplayListComponent title={BATCH} />;
};

export default Batches;
